import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export type BackIconProps = Omit<SVGProps<SVGSVGElement>, 'width' | 'height' | 'viewBox' | 'fill' | 'xmlns'>;
export function BackIcon(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M23 9H1M1 9L8.65217 1M1 9L8.65217 17" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="1em" height="1em" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="close-icon" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}